<template>
  <div class="skeleton-head-provider">
    <div class="skeleton-head-provider__top">
      <UiSkeleton class="skeleton-head-provider__logo" />

      <UiSkeleton
        class="skeleton-head-provider__title"
        class-name="skeleton-head-provider__title-item"
        :items="2"
      />
    </div>

    <UiSkeleton
      class="skeleton-head-provider__tabs"
      class-name="skeleton-head-provider__tabs-item"
      :items="3"
    />
  </div>
</template>

<script>
export default {
  name: 'SkeletonHeadProvider',
}
</script>

<style lang="scss" scoped>
.skeleton-head-provider {
  display: flex;
  flex-direction: column;
  margin-bottom: var(--spaces-s);

    @include media(tablet-album) {
      width: calc(308px + var(--spaces-xl));
      margin-right: var(--spaces-xl);
    }

  &__top {
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: var(--spaces-s);
    padding: var(--padding-xl) var(--padding-m) var(--padding-l) var(--padding-m);
    margin: var(--padding-m);

    @include media(tablet-album) {
      flex-direction: column;
    }
  }

  ::v-deep &__logo.skeleton {
    width: 68px;
    height: 68px;
    border-radius: 50%;

    @include media(tablet-album) {
      width: 120px;
      height: 120px;
      margin-bottom: 8px;
    }
  }

  &__title {
    display: flex;
    flex-direction: column;

    @include media(tablet-album) {
      align-items: center;
    }
  }

  ::v-deep &__title-item {
    &:nth-child(1) {
      width: 140px;
      height: 20px;
      margin-bottom: 4px;

      @include media(tablet-album) {
        height: 24px;
        margin-bottom: 8px;
      }
    }

    &:nth-child(2) {
      width: 80px;
      height: 16px;

      @include media(tablet-album) {
        height: 20px;
      }
    }
  }

  &__tabs {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    column-gap: 20px;
    row-gap: var(--spaces-m);
    padding: var(--spaces-m);
  }

  ::v-deep &__tabs-item {
    width: 120px;
    height: 32px;

    @include media(tablet-album) {
      height: 44px;
    }
  }
}
</style>
